var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "starred"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 15,
    height: 15,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_629",
    "data-name": "Mask Group 629",
    transform: "translate(-39 -143)",
    clipPath: "url(#starred)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_72_",
    "data-name": "svgexport-6 (72)",
    transform: "translate(38.999 143.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11482",
    "data-name": "Path 11482",
    d: "M12.252,15.494a1.208,1.208,0,0,1-.566-.14l-3.238-1.7a.173.173,0,0,0-.163,0l-3.238,1.7a1.215,1.215,0,0,1-1.763-1.281l.618-3.6a.175.175,0,0,0-.052-.156L1.233,7.758a1.215,1.215,0,0,1,.675-2.072L5.526,5.16a.175.175,0,0,0,.132-.1L7.275,1.784a1.214,1.214,0,0,1,2.178,0l1.618,3.28a.177.177,0,0,0,.132.1l3.621.526A1.215,1.215,0,0,1,15.5,7.757L12.88,10.31a.176.176,0,0,0-.052.156l.618,3.6a1.216,1.216,0,0,1-1.195,1.421Zm-3.885-2.9a1.208,1.208,0,0,1,.565.14l3.237,1.7a.167.167,0,0,0,.185-.013.169.169,0,0,0,.07-.172l-.619-3.605a1.217,1.217,0,0,1,.349-1.075l2.62-2.553a.176.176,0,0,0-.1-.3l-3.62-.526a1.213,1.213,0,0,1-.914-.664l-1.62-3.28a.176.176,0,0,0-.315,0L6.59,5.524a1.213,1.213,0,0,1-.915.664l-3.619.527a.175.175,0,0,0-.1.3L4.578,9.568a1.217,1.217,0,0,1,.349,1.075l-.619,3.605a.176.176,0,0,0,.256.185l3.237-1.7a1.213,1.213,0,0,1,.565-.14Z",
    transform: "translate(-0.866 -1.106)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarred);
export default __webpack_public_path__ + "static/media/starred.4bfbd06523e58632588f9df59c04b769.svg";
export { ForwardRef as ReactComponent };